import React from "react";
import { isStringControl, rankWith } from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";

export const materialTextControl = (props) => {
  if (!props.visible) {
    return null;
  }

  return (
    <>
      <strong>{props.label}:</strong>&nbsp;
      {props.data}
    </>
  );
};

export const materialTextControlTester = rankWith(2, isStringControl);
export default withJsonFormsControlProps(materialTextControl);
